var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 5.375L5.75 5.375C4.64543 5.375 3.75 6.27043 3.75 7.375L3.75 16.7812C3.75 17.8858 4.64543 18.7813 5.75 18.7813L7.92857 18.7813L7.92857 22.1134C7.92857 22.5484 8.44573 22.7759 8.76643 22.482L12.8036 18.7813L21.25 18.7813C22.3546 18.7813 23.25 17.8858 23.25 16.7813L23.25 7.375C23.25 6.27043 22.3546 5.375 21.25 5.375Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.46e4c2214015a3bf85df7f40593a878e.svg";
export { ForwardRef as ReactComponent };